import { deleteCustomer, list } from 'api/customers'
import DeleteModal from 'components/DeleteModal'
import LargeHeader from 'components/headers/LargeHeader'
import Loader from 'components/Loader'
import Panel from 'components/panel/Panel'
import Tooltip from 'components/Tooltip'
import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { Pencil, People, Trash } from 'react-bootstrap-icons'
import Container from 'react-bootstrap/Container'
import Table from 'react-bootstrap/Table'
import { Link } from 'react-router-dom'

function Customers(props) {
  const [loading, setLoading] = useState(true)
  const [customers, setCustomers] = useState({})
  const [deleting, setDeleting] = useState(false)
  const [deleteOpen, setDeleteOpen] = useState(false)
  const [deleteId, setDeleteId] = useState('')
  const [deleteIndex, setDeleteIndex] = useState('')
  const [deleteError, setDeleteError] = useState('')

  useEffect(() => {
    const fetchData = async () => {
      const res = await list()
      setCustomers(res)
      setLoading(false)
    }

    fetchData()
  }, [])

  const handleOpenDeleteDialog = (id, index) => {
    setDeleteId(id)
    setDeleteIndex(index)
    setDeleteOpen(true)
  }

  const handleCloseDeleteDialog = () => {
    setDeleteOpen(false)
  }

  const handleDelete = async (id, index) => {
    setDeleteError(false)
    setDeleting(true)
    const success = await deleteCustomer(id)

    if (success) {
      const res = await list()
      setCustomers(res)
      setDeleteOpen(false)
    } else {
      setDeleteError(true)
    }

    setDeleting(false)
  }

  if (loading) {
    return <Loader />
  }

  return (
    <Container>
      <LargeHeader>Customers</LargeHeader>
      <Tooltip label='Create a new customer'>
        <Button className='mb-3' variant='success' as={Link} to='/customers/create'>
          Create
        </Button>
      </Tooltip>

      <Panel>
        {customers.data.length === 0 ? (
          <div>No customers created yet.</div>
        ) : (
          <Table responsive>
            <thead>
              <tr>
                <th>Name</th>
                <th>Package</th>
                <th>Users</th>
                <th>Displays</th>
                <th>Media</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {customers.data.map((x, index) => (
                <tr key={x.id}>
                  <td>{x.name}</td>
                  <td>{x.package.name}</td>
                  <td>
                    {x.usage.users} of {x.package.user_limit}
                  </td>
                  <td>
                    {x.usage.screens} of {x.package.screen_limit}
                  </td>
                  <td>
                    {x.usage.media_mb} of {x.package.media_limit_mb}MB
                  </td>
                  <td className='row-actions'>
                    <Tooltip label={`Manage customer's users`}>
                      <Button
                        className='mr-1 px-2'
                        variant='primary'
                        size='sm'
                        as={Link}
                        to={`/users/customer/${x.id}`}>
                        <People />
                      </Button>
                    </Tooltip>
                    <Tooltip label='Edit Customer'>
                      <Button
                        className='mr-1 px-2'
                        variant='primary'
                        size='sm'
                        as={Link}
                        to={`/customers/update/${x.id}`}>
                        <Pencil />
                      </Button>
                    </Tooltip>
                    <Tooltip label='Delete Customer'>
                      <Button
                        variant='danger'
                        className='px-2'
                        size='sm'
                        onClick={() => handleOpenDeleteDialog(x.id, index)}>
                        <Trash />
                      </Button>
                    </Tooltip>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Panel>

      <DeleteModal
        show={deleteOpen}
        onHide={handleCloseDeleteDialog}
        deleting={deleting}
        onDelete={() => handleDelete(deleteId, deleteIndex)}
        errorMessage={deleteError}
      />
    </Container>
  )
}

export default Customers
